var alignmentStyle = {"alignLeft":"g2BgN","textWrapNowrap":"vQ3Mx","alignRight":"E0ZOH","alignCenter":"_2wqgZ","sizeFullWidth":"_0HmIo","renderedInTable":"_3oUWm","sizeOriginal":"_0d11K","sizeContent":"_0KQIE","sizeSmall":"UfLcW","sizeSmallCenter":"DYuF9","flex":"R9RZH","LEFT":"d-dqv","CENTER":"_2Ipgc","RIGHT":"YY9tN","AUTO":"_5R9mR","JUSTIFY":"pCp3X"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-33864b1a.js.map
